import { matchPath } from 'react-router';
import { ERouteScenario } from 'src/enums';
import { OrderScenario } from 'components/order/model/Order';
import { AUTH_FLOW_ROUTES } from 'pages/routes';

const ROUTE_TO_NORMAL_SCENARIO: Record<Partial<ERouteScenario>, OrderScenario> = {
    [ERouteScenario.ORDER_TO_TABLE]: OrderScenario.ORDER_TO_TABLE,
    [ERouteScenario.PREORDER]: OrderScenario.PREORDER,
    [ERouteScenario.TABLE]: OrderScenario.TABLE,
    [ERouteScenario.PAYATPOS]: OrderScenario.PAYATPOS,
    [ERouteScenario.TAB]: OrderScenario.TAB,
    [ERouteScenario.DINE_IN]: OrderScenario.DINE_IN,
    [ERouteScenario.DELIVERY]: OrderScenario.DELIVERY
};

export const getRouteScenario = (shortScenario: ERouteScenario) => ROUTE_TO_NORMAL_SCENARIO[shortScenario];

export const makeRouteScenario = (scenario: OrderScenario) =>
    ERouteScenario[scenario as keyof typeof ERouteScenario];

/** True when `pathname` matches any of the given route patterns.
 *  react-router v6+ signature is `matchPath(pattern, pathname)` — pattern first. */
export const isPathMatchingRoutes = (pathname: string, routes: string[]): boolean =>
    routes.some(route => !!matchPath(route, pathname));

/** True for pages of the auth flow (sign-in/up, activate, …). These are never valid
 *  post-login return URLs — redirecting a logged-in user back to one traps them there. */
export const isAuthFlowPath = (pathname: string): boolean => isPathMatchingRoutes(pathname, AUTH_FLOW_ROUTES);
